import React, { FC, useEffect } from 'react';
import { PageTitle } from '../../layout/core';
import { GetUserInformation, ProfileSettingsLayout } from '../../components/profileSettings/ProfileSettingsLayout';
import { ProfileSettingsBusinessSettings } from '../../components/profileSettings/ProfileSettingsBusinessSettings';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useIdentity } from '../../store/identyti/identity-context';
import { Spinner } from '../../components/Spinner';
import { fetchSecurityInformation } from '../../store/identyti/actions/security';
import { fetchMerchantData } from '../../store/merchnts/actions/merchant';


export const BusinessSettings: FC = () => {
    const { dispatch } = useMerchants();
    const { identityState: { isSecurityDataLoading }, dispatch: identityDispatch } = useIdentity();
    const user = GetUserInformation();
    const id = user['custom:mid'];

    useEffect(() => {
        void fetchMerchantData(dispatch, id);
    }, []);

    useEffect(() => {
        const email = localStorage.getItem('userEmail');
        void fetchSecurityInformation(identityDispatch, email);
    }, []);

    return (
        <>
            <PageTitle breadcrumbs={[]}>Profile and Settings</PageTitle>
            <ProfileSettingsLayout />
            {
                isSecurityDataLoading
                    ? (
                        <div className="card">
                            <div className="card-body page-loading-height">
                                <Spinner pageLoader/>
                            </div>
                        </div>
                    ) : (
                        <ProfileSettingsBusinessSettings/>
                    )
            }
        </>
    );
};
